import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { useAPI } from '@providers/useAPI';
import { useAuthContext } from '@providers/AuthProvider';
import { useMutation } from '@tanstack/react-query';
import { WorkspacesService } from 'app/API';
import { ApiCallError } from 'app/http/ApiCallError';
import { getApiCallErrorMessage } from 'app/http/getApiCallErrorMessage';
import { TWorkspace } from 'app/types/entities/TWorkspace';
import { useState } from 'react';

type TProps = {
  workspace: TWorkspace;
  onCancel: () => void;
  onSuccess: () => void;
};

export const DeleteWorkspaceModal = ({ workspace, onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();
  const { removeWorkspace } = useAuthContext();
  const [error, setError] = useState<string | null>(null);

  const deleteWorkspaceMutation = useMutation({
    mutationFn: () => call(() => WorkspacesService.deleteWs({ wsid: workspace.id })),
    onMutate: () => {
      setError(null);
    },
    onSuccess: (data) => {
      if (data.error) {
        setError(data.error);
        return;
      }
      removeWorkspace(workspace.id);
      onSuccess();
    },
    onError: (mutationError) => {
      setError(mutationError instanceof ApiCallError ? getApiCallErrorMessage(mutationError) : 'Something went wrong.');
    },
  });

  return (
    <ModalWrapper width="330px">
      {deleteWorkspaceMutation.isPending ? <AbsoluteSpinner overlay={true} /> : null}
      <ModalTitle>Confirm</ModalTitle>
      <div className="text-center">Are you sure you want to delete {workspace.name} workspace?</div>
      {error && <div className="-mt-5 text-center text-[10px] font-medium text-[#ff2f2f]">{error}</div>}
      <div className="flex justify-between">
        <OutlinedButton onClick={onCancel} style={{ width: '130px' }}>
          Cancel
        </OutlinedButton>
        <Button
          onClick={() => deleteWorkspaceMutation.mutate()}
          disabled={deleteWorkspaceMutation.isPending}
          style={{ width: '130px' }}
        >
          Delete
        </Button>
      </div>
    </ModalWrapper>
  );
};
